/* eslint-disable no-restricted-imports */
import React from 'react';
import MuiDialogContent from '@mui/material/DialogContent';

/**
 * A simple wrapper for the content of the Modal.
 */
export const ModalContent = ({children}: React.PropsWithChildren<object>) => {
    return <MuiDialogContent sx={{paddingX: 0, paddingY: 2}}>{children}</MuiDialogContent>;
};
